import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import Image from "../elements/Image";
import Modal from "../elements/Modal";

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const DirectInstallProgramHero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = e => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = e => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom text-color-primary"
              data-reveal-delay="200"
              style={{ textAlign: "center" }}
            >
              Direct Install Program
            </h1>
            <div
            className="hero-figure reveal-from-bottom illustration-element-01"
            data-reveal-value="20px"
            data-reveal-delay="800"
          >
            <Image
              className="has-shadow"
              src={require("./../../assets/images/house-blueprint.png")}
              alt="Hero"
              width={896}
              height={504}
            />
          </div>
          <div>
          <h1
              className="mt-0 mb-16"
              data-reveal-delay="200"
              style={{ textAlign: "center" }}
            >
              What is a Direct Install Program?
            </h1>
            <p style={{ textAlign: "left" }}>
              <ul>
                <li>
                Train and Provide Certified Energy Efficiency Technicians                </li>
                <li>
                Calculate Energy Savings of Energy Efficiency Measures (EEM)s based on Technical Resource Manuals (TRMs)                </li>
                <li>
                Manage and Store Energy Efficiency Measures Inventory
                </li>
                <li>
                Technicians install Energy Efficiency Measures in Residences to ensure Energy Savings                 </li>
                <li>
                Guarantee acceptability of reported energy savings to regulatory agencies
                </li>
               
              </ul>
            </p>
            </div>
            <div className="container-xs">
              <p
                className="m-0 mb-32 reveal-from-bottom"
                data-reveal-delay="400"
              ></p>
            </div>
          </div>
         
        </div>
      </div>
    </section>
  );
};

DirectInstallProgramHero.propTypes = propTypes;
DirectInstallProgramHero.defaultProps = defaultProps;

export default DirectInstallProgramHero;
